export const SET_CAMPER_FORM = 'SET_CAMPER_FORM'
export const SET_CAMPER_FORM_FIELD = 'SET_CAMPER_FORM_FIELD'
